"use client";

import { usePrTheme } from "@/app/components/themeProvider/pr-theme-provider";
import { useWidgetConfig, WidgetConfig } from "@/app/components/widget/widget-config";
import { usePathname } from "next/navigation";

interface PrThemeContextType {
  primary_color: string;
  accent_color: string;
  secondary_color: string;
  tertiary_color: string;
  isDefault?: boolean;
}

export type ThemeMode = 'main' | 'widget' | 'auto';

export interface PromptBarTheme {
  type: 'main' | 'widget';
  mainTheme?: PrThemeContextType;
  widgetConfig?: WidgetConfig;
}

/**
 * Hook that detects and returns the appropriate theme for the prompt bar
 * based on the current route and explicit theme mode
 */
export function usePromptBarTheme(themeMode: ThemeMode = 'auto'): PromptBarTheme {
  const mainTheme = usePrTheme();
  const widgetConfig = useWidgetConfig();
  const pathname = usePathname();
  
  // Auto-detect based on route
  if (themeMode === 'auto') {
    const isWidget = pathname.includes('/widget');
    return isWidget 
      ? { type: 'widget', widgetConfig }
      : { type: 'main', mainTheme };
  }
  
  return themeMode === 'widget' 
    ? { type: 'widget', widgetConfig }
    : { type: 'main', mainTheme };
}

